// fetch api calls
export const FETCH_AUTH_SUCCESS = "FETCH_AUTH_SUCCESS";
export const FETCH_USER_SESSION_SUCCESS = "FETCH_USER_SESSION_SUCCESS";
export const FETCH_LIST_POSTED_SCHEDULES_SUCCESS = "FETCH_LIST_POSTED_SCHEDULES_SUCCESS";
export const FETCH_LIST_PREVIOUS_POSTINGS_SUCCESS = "FETCH_LIST_PREVIOUS_POSTINGS_SUCCESS";
export const FETCH_FIND_RESOURCE_SUCCESS = "FETCH_FIND_RESOURCE_SUCCESS";
export const FETCH_POSTED_SCHEDULES_SUCCESS = "FETCH_POSTED_SCHEDULES_SUCCESS";
export const FETCH_POSTED_SCHEDULES_JSON_SUCCESS = "FETCH_POSTED_SCHEDULES_JSON_SUCCESS";
export const FETCH_LIVE_SCHEDULES_SUCCESS = "FETCH_LIVE_SCHEDULES_SUCCESS";
export const FETCH_LIST_RESOURCE_COLLECTION_SUCCESS = "FETCH_LIST_RESOURCE_COLLECTION_SUCCESS";
export const FETCH_DETAILED_SCHEDULES_SUCCESS = "FETCH_DETAILED_SCHEDULES_SUCCESS";
export const FETCH_SELECTED_RESOURCE_COLLECTION = "FETCH_SELECTED_RESOURCE_COLLECTION";
export const FETCH_DAY_TYPE_CALENDAR_SUCCESS = "FETCH_DAY_TYPE_CALENDAR_SUCCESS";
export const FETCH_DAY_TYPE_SECURITY_SUCCESS = "FETCH_DAY_TYPE_SECURITY_SUCCESS";
export const FETCH_CREATE_TOUR_PRE_REQ_SUCCESS = "FETCH_CREATE_TOUR_PRE_REQ_SUCCESS";
export const FETCH_DAY_TYPE_REQUESTS_BY_YEAR = "FETCH_DAY_TYPE_REQUESTS_BY_YEAR";
export const FETCH_DAY_TYPE_REQUEST_BY_ID = "FETCH_DAY_TYPE_REQUEST_BY_ID";
export const FETCH_LIST_MY_QUICK_SCHEDULES_SUCCESS = "FETCH_LIST_MY_QUICK_SCHEDULES_SUCCESS";
export const FETCH_RESOURCE_DAY_TYPE_BY_DATE_SUCCESS = "FETCH_RESOURCE_DAY_TYPE_BY_DATE_SUCCESS";
export const FETCH_RESOURCE_DAY_TYPE_BY_ID_SUCCESS = "FETCH_RESOURCE_DAY_TYPE_BY_ID_SUCCESS";
export const FETCH_DAY_TYPES_ALL_SUCCESS = "FETCH_DAY_TYPES_ALL_SUCCESS";
export const FETCH_DAY_TYPES_ALL_WITHOUT_FORCE_TOUR_SUCCESS = "FETCH_DAY_TYPES_ALL_WITHOUT_FORCE_TOUR_SUCCESS";
export const FETCH_RESOURCE_PERSONNEL_DATA_SUCCESS = "FETCH_RESOURCE_PERSONNEL_DATA_SUCCESS";
export const FETCH_ACTIVITY_TYPES_SUCCESS = "FETCH_ACTIVITY_TYPES_SUCCESS";
export const FETCH_RELATED_BRANCHES_SUCCESS = "FETCH_RELATED_BRANCHES_SUCCESS";
export const FETCH_SERVICES_BY_DATE_SUCCESS = "FETCH_SERVICES_BY_DATE_SUCCESS";
export const FETCH_ACTIVE_TOURS_SUCCESS = "FETCH_ACTIVE_TOURS_SUCCESS";
export const FETCH_DEFAULT_TOUR_LENGTH_SUCCESS = "FETCH_DEFAULT_TOUR_LENGTH_SUCCESS";
export const FETCH_RELEVANT_JOBS_SUCCESS = "FETCH_RELEVANT_JOBS_SUCCESS";
export const FETCH_RELEVANT_JOBS_FOR_COST_OBJECT_SUCCESS = "FETCH_RELEVANT_JOBS_FOR_COST_OBJECT_SUCCESS";
export const FETCH_COST_OBJECTS_SUCCESS = "FETCH_COST_OBJECTS_SUCCESS";
export const FETCH_RESOURCE_COLLECTION_INFORMATION = "FETCH_RESOURCE_COLLECTION_INFORMATION";
export const FETCH_MEAL_SUCCESS = "FETCH_MEAL_SUCCESS";
export const FETCH_TOUR_SUCCESS = "FETCH_TOUR_SUCCESS";
export const FETCH_GROUPS_BY_BRANCH_AND_RESOURCE_SUCCESS = "FETCH_GROUPS_BY_BRANCH_AND_RESOURCE_SUCCESS";
export const FETCH_SERVICE_SALARY_LEVEL_SUCCESS = "FETCH_SERVICE_SALARY_LEVEL_SUCCESS";
export const FETCH_SERVICE_PRIMARY_RATE_SUCCESS = "FETCH_SERVICE_PRIMARY_RATE_SUCCESS";
export const FETCH_JOB_SALARIES_BY_SERVICE_SUCCESS = "FETCH_JOB_SALARIES_BY_SERVICE_SUCCESS";
export const FETCH_VALIDATE_EMPTY_JOB_SUCCESS = "FETCH_VALIDATE_EMPTY_JOB_SUCCESS";
export const FETCH_JOB_SUCCESS = "FETCH_JOB_SUCCESS";
export const FETCH_JOB_ELEMENT_SUCCESS = "FETCH_JOB_ELEMENT_SUCCESS";
export const FETCH_COST_OBJECT_SUCCESS = "FETCH_COST_OBJECT_SUCCESS";
export const FETCH_UPDATING_USER_SUCCESS = "FETCH_UPDATING_USER_SUCCESS";
export const FETCH_JOB_ELEMENTS_WITH_DETAILS_SUCCESS = "FETCH_JOB_ELEMENTS_WITH_DETAILS_SUCCESS";
export const FETCH_SERVICE_SUCCESS = "FETCH_SERVICE_SUCCESS";
export const FETCH_GROUPS_BY_BRANCH_IN_COMPANY_SUCCESS = "FETCH_GROUPS_BY_BRANCH_IN_COMPANY_SUCCESS";
export const FETCH_ASSIGNMENT_SERVICES_BY_GROUP_SUCCESS = "FETCH_ASSIGNMENT_SERVICES_BY_GROUP_SUCCESS";
export const FETCH_SERVICES_BY_GROUP_SUCCESS = "FETCH_SERVICES_BY_GROUP_SUCCESS";
export const FETCH_RESOURCE_BY_DATES_SUCCESS = "FETCH_RESOURCE_BY_DATES_SUCCESS";
export const FETCH_BRANCHES_BY_COMPANY_ID_SUCCESS = "FETCH_BRANCHES_BY_COMPANY_ID_SUCCESS";
export const FETCH_DIVISIONS_BY_BRANCH_ID_SUCCESS = "FETCH_DEPARTMENTS_BY_BRANCH_ID_SUCCESS"
export const FETCH_DEPARTMENTS_BY_COMPANY_ID_BRANCH_ID_DIVISION_ID_SUCCESS = "FETCH_DEPARTMENTS_BY_COMPANY_ID_BRANCH_ID_DIVISION_ID_SUCCESS";
export const FETCH_RESOURCE_COLLECTIONS_BY_USER_ID_GENERAL_ID_COMPANY_ID_SUCCESS = "FETCH_RESOURCE_COLLECTIONS_BY_USER_ID_GENERAL_ID_COMPANY_ID_SUCCESS";
export const FETCH_TOUR_APPROVALS_SUCCESS = "FETCH_TOUR_APPROVALS_SUCCESS";
export const FETCH_TIME_KEEPER_REVERSALS_BY_RESOURCE_DAY_TYPE_ID = "FETCH_TIME_KEEPER_REVERSALS_BY_RESOURCE_DAY_TYPE_ID";
export const FETCH_TOUR_IS_DIRECT_BILLING_BY_TOUR_ID = "FETCH_TOUR_IS_DIRECT_BILLING_BY_TOUR_ID";
export const FETCH_CONTACT_INFO_BY_TOUR_ID = "FETCH_CONTACT_INFO_BY_TOUR_ID";
export const FETCH_APPROVED_JOB_ELEMENTS_SUCCESS = "FETCH_APPROVED_JOB_ELEMENTS_SUCCESS";
export const FETCH_JOB_ELEMENTS_SUCCESS = "FETCH_JOB_ELEMENTS_SUCCESS";
export const FETCH_ACTIVITY_FLAG_BY_TOUR_SUCCESS = "FETCH_ACTIVITY_FLAG_BY_TOUR_SUCCESS";
export const FETCH_TOUR_ACTIVITY_FLAGS_SUCCESS = "FETCH_TOUR_ACTIVITY_FLAGS_SUCCESS";
export const FETCH_CODES_BY_INDICATOR_SUCCESS = "FETCH_CODES_BY_INDICATOR_SUCCESS";
export const FETCH_INDICATORS_BY_ID_SUCCESS = "FETCH_INDICATORS_BY_ID_SUCCESS";
export const FETCH_INDICATORS_BY_TOUR_SUCCESS = "FETCH_INDICATORS_BY_TOUR_SUCCESS";
export const FETCH_JOB_ELEMENTS_BY_TOUR_SUCCESS = "FETCH_JOB_ELEMENTS_BY_TOUR_SUCCESS";
export const FETCH_TOUR_MEALS_SUCCESS = "FETCH_TOUR_MEALS_SUCCESS";
export const FETCH_PAY_TRANSACTIONS_BY_TOUR_SUCCESS = "FETCH_PAY_TRANSACTIONS_BY_TOUR_SUCCESS";
export const FETCH_TOUR_ACTIVITY_FLAG_SUCCESS = "FETCH_TOUR_ACTIVITY_FLAG_SUCCESS";
export const FETCH_TOUR_INDICATOR_SUCCESS = "FETCH_TOUR_INDICATOR_SUCCESS";
export const FETCH_TOUR_INDICATORS_SUCCESS = "FETCH_TOUR_INDICATORS_SUCCESS";
export const FETCH_TOUR_PAY_TRANSACTION_SUCCESS = "FETCH_TOUR_PAY_TRANSACTION_SUCCESS";
export const FETCH_TOUR_PAY_TRANSACTIONS_SUCCESS = "FETCH_TOUR_PAY_TRANSACTIONS_SUCCESS";
export const FETCH_RESOURCE_CONTACT_INFO = 'FETCH_RESOURCE_CONTACT_INFO';
export const FETCH_DAY_TYPES_BY_DAY_RULE = 'FETCH_DAY_TYPES_BY_DAY_RULE';
export const FETCH_DAY_TYPES_ALLOWING_TOUR_SCHEDULING = 'FETCH_DAY_TYPES_ALLOWING_TOUR_SCHEDULING';
export const FETCH_BRANCH_SUCCESS = 'FETCH_BRANCH_SUCCESS';
export const FETCH_IF_TOURS_ARE_IN_DATE_RANGE = 'FETCH_IF_TOURS_ARE_IN_DATE_RANGE';
export const FETCH_IF_HAS_HOLIDAY_SCHEDULE_SUCCESS = "FETCH_IF_HAS_HOLIDAY_SCHEDULE_SUCCESS";

// log api calls
export const LOG_JOB_START_SUCCESS = "LOG_JOB_START_SUCCESS";
export const LOG_JOB_FINISH_SUCESS = "LOG_JOB_FINISH_SUCESS";
export const UPDATE_USER_HISTORY_SUCCESS = "UPDATE_USER_HISTORY_SUCCESS";

// add api calls
export const ADD_RESOURCE_DAY_TYPE_SUCCESS = "ADD_RESOURCE_DAY_TYPE_SUCCESS";
export const ADD_TOUR_SUCCESS = "ADD_TOUR_SUCCESS";
export const ADD_MEAL_SUCCESS = "ADD_MEAL_SUCCESS";
export const ADD_DAY_TYPE_SUCCESS = "ADD_DAY_TYPE_SUCCESS";
export const ADD_POSTED_SCHEDULE_SUCCESS = 'ADD_POSTED_SCHEDULE_SUCCESS';
export const ADD_POSTED_SCHEDULE_FAILURE = 'ADD_POSTED_SCHEDULE_FAILURE';
export const ADD_JOB_SUCCESS = "ADD_JOB_SUCCESS";
export const ADD_JOB_ELEMENT_SUCCESS = "ADD_JOB_ELEMENT_SUCCESS";
export const ADD_TOUR_REVERSAL = "ADD_TOUR_REVERSAL";
export const ADD_TOUR_ACTIVITY_FLAG_SUCCESS = "ADD_TOUR_ACTIVITY_FLAG_SUCCESS";
export const ADD_TOUR_INDICATOR_SUCCESS = "ADD_TOUR_INDICATOR_SUCCESS";
export const ADD_TOUR_PAY_TRANSACTION_SUCCESS = "ADD_TOUR_PAY_TRANSACTION_SUCCESS";

// edit api calls
export const EDIT_RESOURCE_DAY_TYPE_SUCCESS = "EDIT_RESOURCE_DAY_TYPE_SUCCESS";
export const UPDATE_MY_QUICK_SCHEDULES_ARRAY = "UPDATE_MY_QUICK_SCHEDULES_ARRAY";
export const EDIT_TOUR_SUCCESS = "EDIT_TOUR_SUCCESS";
export const EDIT_MEAL_SUCCESS = "EDIT_MEAL_SUCCESS";
export const EDIT_DAY_TYPE_SUCCESS = 'EDIT_DAY_TYPE_SUCCESS';
export const EDIT_JOB_ELEMENT_SUCCESS = 'EDIT_JOB_ELEMENT_SUCCESS';
export const EDIT_APPROVAL_PARAMETERS_SUCCESS = "EDIT_APPROVAL_PARAMETERS_SUCCESS";
export const EDIT_APPROVALS_SUCCESS = "EDIT_APPROVALS_SUCCESS";
export const EDIT_JOB_SUCCESS = "EDIT_JOB_SUCCESS";
export const EDIT_TOUR_ACTIVITY_FLAG_SUCCESS = "EDIT_TOUR_ACTIVITY_FLAG_SUCCESS";
export const EDIT_TOUR_INDICATOR_SUCCESS = "EDIT_TOUR_INDICATOR_SUCCESS";
export const EDIT_TOUR_PAY_TRANSACTION_SUCCESS = "EDIT_TOUR_PAY_TRANSACTION_SUCCESS";
export const EDIT_POSTED_SCHEDULE_PARAMETERS_SUCCESS = "EDIT_POSTED_SCHEDULE_PARAMETERS_SUCCESS";
export const EDIT_DETAILED_SCHEDULE_PARAMETERS_SUCCESS = "EDIT_DETAILED_SCHEDULE_PARAMETERS_SUCCESS";
export const EDIT_DAY_TYPE_CALENDAR_SCHEDULE_PARAMETERS_SUCCESS = "EDIT_DAY_TYPE_CALENDAR_SCHEDULE_PARAMETERS_SUCCESS";
export const EDIT_LIVE_SCHEDULE_PARAMETERS_SUCCESS = "EDIT_LIVE_SCHEDULE_PARAMETERS_SUCCESS";


// remove api calls
export const REMOVE_TOUR_SUCCESS = "REMOVE_TOUR_SUCCESS";
export const REMOVE_RESOURCE_DAY_TYPE_SUCCESS = "REMOVE_RESOURCE_DAY_TYPE_SUCCESS";
export const REMOVE_RESOURCE_DAY_TYPE_BY_ID_SUCCESS = "REMOVE_RESOURCE_DAY_TYPE_BY_ID_SUCCESS";
export const REMOVE_DAY_TYPE_SUCCESS = 'REMOVE_DAY_TYPE_SUCCESS';
export const REMOVE_JOB_SUCCESS = 'REMOVE_JOB_SUCCESS';
export const REMOVE_JOB_ELEMENT_SUCCESS = 'REMOVE_JOB_ELEMENT_SUCCESS';
export const REMOVE_MEAL_SUCCESS = "REMOVE_MEAL_SUCCESS";
export const REMOVE_TOUR_ACTIVITY_FLAG_SUCCESS = "REMOVE_TOUR_ACTIVITY_FLAG_SUCCESS";
export const REMOVE_TOUR_INDICATOR_SUCCESS = "REMOVE_TOUR_INDICATOR_SUCCESS";
export const REMOVE_TOUR_PAY_TRANSACTION_SUCCESS = "REMOVE_TOUR_PAY_TRANSACTION_SUCCESS";

// app-level state mgmt.
export const UPDATE_SELECTED_RESOURCE = "UPDATE_SELECTED_RESOURCE";
export const UPDATE_SELECTED_DAY_TYPE_RESOURCE = "UPDATE_SELECTED_DAY_TYPE_RESOURCE";
export const UPDATE_SELECTED_RESOURCE_COLLECTION = "UPDATE_SELECTED_RESOURCE_COLLECTION";
export const UPDATE_EDIT_MODE_STATUS = "UPDATE_EDIT_MODE_STATUS";
export const UPDATE_HAMBURGER_MENU_STATUS = "UPDATE_HAMBURGER_MENU_STATUS";
export const UPDATE_THEME = "UPDATE_THEME";

// app-level state mgmt. - optimistic re-renders
export const UPDATE_LIVE_SCHEDULE_OPTIMISTIC_RERENDER_STATUS = "UPDATE_LIVE_SCHEDULE_OPTIMISTIC_RERENDER_STATUS";
export const UPDATE_OPTIMISTIC_LIVE_SCHEDULE = "UPDATE_OPTIMISTIC_LIVE_SCHEDULE";
export const LIVE_SCHEDULE_DELETE_TOUR_OPTIMISTIC = "LIVE_SCHEDULE_DELETE_TOUR_OPTIMISTIC";
export const LIVE_SCHEDULE_ADD_TOUR_OPTIMISTIC = "LIVE_SCHEDULE_ADD_TOUR_OPTIMISTIC";
export const LIVE_SCHEDULE_EDIT_TOUR_OPTIMISTIC = "LIVE_SCHEDULE_EDIT_TOUR_OPTIMISTIC";
export const LIVE_SCHEDULE_ADD_DAY_TYPE_OPTIMISTIC = "LIVE_SCHEDULE_ADD_DAY_TYPE_OPTIMISTIC";
export const LIVE_SCHEDULE_EDIT_DAY_TYPE_OPTIMISTIC = "LIVE_SCHEDULE_EDIT_DAY_TYPE_OPTIMISTIC";
export const LIVE_SCHEDULE_DELETE_DAY_TYPE_OPTIMISTIC = "LIVE_SCHEDULE_DELETE_DAY_TYPE_OPTIMISTIC";


